module.exports = __webpack_public_path__ + "img/73.a629bf8c.jpg";